import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { FormattedMessage } from '../../../components/I18n';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import styled, { useMediaQuery } from '../../../utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserOwnsPlaylist } from '../savedItemsQueries';

const ButtonImpl = (_ref) => {
  let {
    playlistId,
    $isHiddenFor,
    use = 'link'
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["playlistId", "$isHiddenFor", "use"]);

  const ownedByUser = useUserOwnsPlaylist(playlistId);
  const {
    matches
  } = useMediaQuery($isHiddenFor);
  if (!ownedByUser || matches) return null;

  const onEditPlaylistClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'edit-details-click',
      playlistId
    });
  };

  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, props, {
    onClick: onEditPlaylistClick,
    to: `${MY_PLAYLISTS_URL_FRAGMENT}/${playlistId}/edit-playlist`,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.editDetails"
    })
  }));
};

export const EditPlaylistButton = styled(ButtonImpl).withConfig({
  displayName: "EditPlaylistButton",
  componentId: "sc-1jcw5v2-0"
})(["&&{width:auto;font-weight:500;margin-top:0 !important;}"]);